import { useFormContext } from 'react-hook-form';
import classNames from 'classnames';
import styles from './CheckboxField.module.scss';
import { useFieldValidity } from '../../../pages/ApplicationV3/hooks/useFieldValidity';
import sanitize from 'sanitize-html';

export const Cypress_data = {
  wrapper: 'base-checkbox-field-wrapper',
  input: 'base-checkbox-field',
  label: 'base-checkbox-label',
};

interface CheckboxFieldProps {
  name: string;
  label: string;
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const CheckboxField = ({
  name,
  label,
  disabled,
  onChange,
}: CheckboxFieldProps) => {
  const { register, watch } = useFormContext();
  const { error } = useFieldValidity(name);
  const checked = Boolean(watch(name));

  return (
    <div className={styles.wrapper} data-cy={Cypress_data.wrapper}>
      <label className={styles.label}>
        <input
          type="checkbox"
          {...register(name, {
            onChange: onChange,
          })}
          checked={checked}
          disabled={disabled}
          className={classNames(styles.checkbox, {
            [styles.disabled]: disabled,
          })}
          data-cy={Cypress_data.input}
        />
        <div
          className={styles.text}
          data-cy={Cypress_data.label}
          dangerouslySetInnerHTML={{ __html: sanitize(label) }}
        />
      </label>
      {error && (
        <span className={styles.errorText} data-cy="base-error-text">
          {error.message}
        </span>
      )}
    </div>
  );
};

export default CheckboxField;
